export const checkAuthToken = () => {
    const authToken = sessionStorage.getItem("Authorization");
    if (authToken && authToken !== "null") {
        return true;
    }
    return false;
};

export const setAuthToken = (authToken, refreshToken) => {
    sessionStorage.setItem("Authorization", authToken);
    sessionStorage.setItem("RefreshToken", refreshToken);
};

export const getAuthToken = () => ({
    authToken: sessionStorage.getItem("Authorization"),
    refreshToken: sessionStorage.getItem("RefreshToken")
});

export const removeAuthToken = () => {
    sessionStorage.removeItem("Authorization");
    sessionStorage.removeItem("RefreshToken");
};
